import { Box } from '../../Box/Box';

import { barContainerRecipe, barRecipe } from './LinearProgress.css';

interface LinearProgressProps {
  /** The value for the progress indicator. Value between 0 and 100 */
  value: number;
  size?: 'standard' | 'large';
  tone?: 'neutral' | 'success' | 'warning';
  rounded?: boolean;
}

export const LinearProgress = ({
  value,
  size = 'standard',
  tone = 'neutral',
  rounded = false,
}: LinearProgressProps): JSX.Element => {
  const translateOffset = Math.round(100 - value);
  return (
    <Box aria-valuenow={Math.round(value)} className={barContainerRecipe({ size, tone, rounded })}>
      <Box
        style={{
          transform: `translateX(-${translateOffset}%)`,
        }}
        className={barRecipe({ tone, size, rounded })}
      />
    </Box>
  );
};
